import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromMemberForm from '../reducers/member-form.reducer';

// tslint:disable-next-line:max-line-length
export const getMemberFormState = createSelector(
  fromFeature.getMemberFormFormState,
  (state: fromFeature.MemberFormState) => state.memberForm
);

export const getMemberForm = createSelector(getMemberFormState, fromMemberForm.getMemberForm);
export const getMemberFormSaved = createSelector(getMemberFormState, fromMemberForm.getMemberFormSaved);
export const getMemberFormSaving = createSelector(getMemberFormState, fromMemberForm.getMemberFormSaving);
export const getMemberFormSaveError = createSelector(getMemberFormState, fromMemberForm.getMemberFormSaveError);
export const getMemberFormSubmitted = createSelector(getMemberFormState, fromMemberForm.getMemberFormSubmitted);
